import axios from "@/libs/api.request";
// 获取列表
export const getAgents = () => {
  return axios.request({
    url: "/tracker/agentTrace/getAgents",
    method: "get"
  });
};

export const getAgentTrace = params => {
  return axios.request({
    url: "/tracker/agentTrace",
    method: "get",
    params
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/tracker/agentTrace/${id}`,
    method: "get"
  });
};

export const add = data => {
  return axios.request({
    url: "/tracker/agentTrace",
    method: "post",
    data
  });
};

export const update = data => {
  return axios.request({
    url: `/tracker/agentTrace/${data.id}`,
    method: "put",
    data
  });
};

export const del = id => {
  return axios.request({
    url: `/tracker/agentTrace/${id}`,
    method: "delete"
  });
};
